/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

//Navigate to home page when not on the home page
const handleCoverageCheck = function (item: FuseNavigationItem) {

};


// background colors are edited directly on the html component
export const defaultNavigation: FuseNavigationItem[] =
    [
        {
            id: 'home',
            title: 'Home',
            type: 'basic',
            externalLink: false,
            link: 'home',
            classes:
            {
                wrapper: 'rounded-full background-button-white',
                title: "max-lg:text-xl font-bold text-lg"
            },
        },
          {
            id: '',
            title: 'About Us',
            type: 'basic',
            externalLink: false,
            link: 'about-us',

            classes:
            {
                wrapper: 'rounded-full background-button-white',
                title: "max-lg:text-xl font-bold text-lg"
            },

        },
        {
            id: 'packages',
            title: 'Packages',
            type: 'basic',
            externalLink: false,
            link: 'product-overview',
            classes:
            {
                wrapper: 'rounded-full background-button-white',
                title: "max-lg:text-xl font-bold text-lg"
            },
        },
        // {
        //     id: '',
        //     title: 'Blogs',
        //     type: 'basic',
        //     externalLink: false,
        //     link: 'blogs',

        //     classes:
        //     {
        //         wrapper: 'rounded-full background-button-white',
        //         title: "max-lg:text-xl font-bold text-lg"
        //     }

        // },
      
        {
            id: 'contact',
            title: 'Contact Us',
            type: 'basic',
            externalLink: false,
            link: 'contact-us',
            classes:
            {
                wrapper: 'rounded-full background-button-white',
                title: "max-lg:text-xl font-bold text-lg"
            },
        },
    ];




export const horizontalNavigationLoggedIn: FuseNavigationItem[] = [
    {
        id: 'home',
        title: 'Home',
        type: 'basic',
        externalLink: false,
        link: 'home',
        classes: {
            wrapper: 'rounded-full background-button-white ',
            title: 'text-lg font-semibold'
        }
    },
    {
        id: 'about',
        title: 'About Us',
        type: 'basic',
        externalLink: false,
        link: 'about-us',
        classes: {
            wrapper: 'rounded-full background-button-white',
            title: 'text-lg font-semibold'
        }
    },
    {
        id: 'packages',
        title: 'Packages',
        type: 'basic',
        externalLink: false,
        link: 'product-overview',
        classes: {
            wrapper: 'rounded-full background-button-white ',
            title: 'text-lg font-semibold'
        }
    },
    // {
    //     id: 'blog',
    //     title: 'Blogs',
    //     type: 'basic',
    //     externalLink: false,
    //     link: 'blogs',
    //     classes: {
    //         wrapper: 'rounded-full background-button-white',
    //         title: 'text-lg font-semibold'
    //     }
    // },

    {
        id: 'contact',
        title: 'Contact',
        type: 'basic',
        externalLink: false,
        link: 'contact-us',
        classes: {
            wrapper: 'rounded-full background-button-white',
            title: 'text-lg font-semibold'
        }
    },

];



export const horizontalNavigationProfile: FuseNavigationItem[] = [


];


export const defaultNavigationLoggedIn: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];

export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];

export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];

export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'home',
        title: 'Home',
        type: 'basic',
        externalLink: false,
        link: 'home',
        classes:
        {
            wrapper: 'rounded-full background-button-white',
            title: "max-lg:text-xl font-bold text-lg"
        },
    },
    {
        id: '',
        title: 'About Us',
        type: 'basic',
        externalLink: false,
        link: 'about-us',

        classes:
        {
            wrapper: 'rounded-full background-button-white',
            title: "max-lg:text-xl font-bold text-lg"
        },

    },
    {
        id: 'packages',
        title: 'Packages',
        type: 'basic',
        externalLink: false,
        link: 'product-overview',
        classes:
        {
            wrapper: 'rounded-full background-button-white',
            title: "max-lg:text-xl font-bold text-lg"
        },
    },
    // {
    //     id: '',
    //     title: 'Blogs',
    //     type: 'basic',
    //     externalLink: false,
    //     link: 'blogs',

    //     classes:
    //     {
    //         wrapper: 'rounded-full background-button-white',
    //         title: "max-lg:text-xl font-bold text-lg"
    //     }

    // },
    {
        id: 'contact',
        title: 'Contact Us',
        type: 'basic',
        externalLink: false,
        link: 'contact-us',
        classes:
        {
            wrapper: 'rounded-full background-button-white',
            title: "max-lg:text-xl font-bold text-lg"
        }
    }
];
